import React, { memo } from "react";
import RiskScoreStrip from "./RiskScoreStrip";
import { COMMON_STYLES, COLORS } from "../constants";

interface AmlockViewProps {
  amlockDetails?: any
}

const AmlockView: React.FC<AmlockViewProps> = ({ amlockDetails }) => {
  // Use provided score or fall back to mock data for development
  const amlockScore = amlockDetails?.riskScore !== undefined ? amlockDetails?.riskScore : 0;

  return (
    <div className="container mt-4">
      <p
        className="text-dark m-0"
        style={{
          ...COMMON_STYLES.sectionTitle,
          color: COLORS.TEXT_PRIMARY,
        }}
      >
        Amlock
      </p>
      <hr />
      <div
        style={{
          height: 100,
          alignContent: "center",
          marginBottom: 20,
        }}
      >
        <RiskScoreStrip score={amlockScore} />
      </div>
    </div>
  );
};

export default memo(AmlockView);
